/**
 * Links into the customer portal (portal.paznetworks.com / localhost:3000).
 *
 * `VITE_CUSTOMER_PORTAL_URL` overrides the origin; otherwise the origin is
 * derived from where the admin app is running (localhost → :3000, staging →
 * portal.staging…, anything else → production).
 */
import { resolveAppUrl } from '@pazportal/ui';
import { VIEW_AS_QUERY_PARAM } from '@pazportal/types';

export function portalUrl(path: string): string {
  return resolveAppUrl('customer-portal', path, {
    override: import.meta.env.VITE_CUSTOMER_PORTAL_URL,
  });
}

/** Opens the portal dashboard as the given portal user (`users.id`). */
export function portalViewAsUrl(userId: string): string {
  return portalUrl(`/dashboard?${VIEW_AS_QUERY_PARAM}=${encodeURIComponent(userId)}`);
}

/** The portal's staff picker for choosing a user to view as. */
export function portalViewAsPickerUrl(): string {
  return portalUrl('/staff/view-as');
}

export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}

export function openInNewTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
